import { ResponsivePie } from "@nivo/pie";

// Components
import ChartSkeleton from "./ChartSkeleton";

const OrderChart = ({ isLoading, orderStatus }) => {
    return (
        <>
            <div className="grid grid-cols-2 items-center max-[1600px]:gap-5 max-[1600px]:ml-5 pb-6">
                <div className="col-span-1 h-48 flex items-center justify-center">
                    {orderStatus.some((item) => Number(item.value) > 0) ? (
                        <ResponsivePie
                            data={orderStatus.map((item) => ({
                                id: item.id,
                                label: item.label,
                                value: item.value,
                                color: item.color,
                            }))}
                            colors={{ datum: "data.color" }}
                            margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                            innerRadius={0.5}
                            activeOuterRadiusOffset={8}
                            borderWidth={1}
                            borderColor={{
                                from: "color",
                                modifiers: [["darker", 0.2]],
                            }}
                            enableArcLinkLabels={false}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#333333"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsColor={{ from: "color" }}
                            enableArcLabels={false}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={{
                                from: "color",
                                modifiers: [["darker", 2]],
                            }}
                        />
                    ) : (
                        <p className="text-gray-500 text-sm">No data found</p>
                    )}
                </div>
                <div className="col-span-1 flex">
                    <div className="flex flex-col justify-center items-start gap-5 max-[1600px]:gap-3">
                        {orderStatus.map((item, index) => {
                            return (
                                <div
                                    className="w-full flex justify-between items-center gap-10 max-[1600px]:gap-3"
                                    key={index}
                                >
                                    <div className="flex justify-start items-center gap-3">
                                        <span
                                            className={`w-[10px] h-[10px] rounded-full`}
                                            style={{
                                                backgroundColor: item.color,
                                            }}
                                        ></span>
                                        <p className="text-xs font-inter font-medium text-ec-body">
                                            {item.label}
                                        </p>
                                    </div>

                                    <p className="text-sm font-inter font-bold text-ec-body">
                                        {item.value}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderChart;
